<div class="screen">
  <canvas #graphCanvas class="screen__graph-canvas"></canvas>
  <div class="screen__backdrop screen__backdrop--first"></div>
  <div class="screen__backdrop screen__backdrop--second"></div>

  <div
    class="wrapper"
    [class.wrapper--expanded]="isExpandedLayout() && !isContractsWide()"
    [class.wrapper--wide-flow]="isContractsWide()"
  >
    <!-- Iframe account selection overlay - shows when account needs to be selected -->
    @if (shouldShowAccountSelectionOverlay()) {
      <app-iframe-account-selection (accountSelected)="onAccountSelected()" />
    }

    <!-- Iframe loading spinner - shows during initial load -->
    @if (shouldEnforceAccountSelection() && showIframeLoader()) {
      <div class="iframe-overlay-cover">
        <div class="iframe-loader">
          <kc-spinner size="lg" />
        </div>
      </div>
    }

    @if (isExpandedLayout() && !isContractsWide()) {
      <!-- ── EXPANDED MODE: two-column layout ── -->
      <div class="wrapper__left">
        <div
          [@navAnimation]="getRouteAnimationData()"
          class="wrapper__content full-width"
        >
          <div class="wrapper__header">
            <app-wrapper-header />
          </div>
          <router-outlet #outlet="outlet" />
        </div>
        <div class="wrapper__nav">
          <app-wrapper-nav />
        </div>
      </div>

      <div class="wrapper__right">
        <!-- Right-panel header (title + navigation controls) -->
        <div class="wrapper__right-header">
          @if (
            flowPagesService.isAnyPageOpen() &&
            (flowPagesService.activePage()?.showTitle ?? true)
          ) {
            <div class="wrapper__right-nav">
              @if (flowPagesService.canNavigateBack()) {
                <kc-icon
                  class="wrapper__right-back"
                  [iconClass]="'icon-chevron-left'"
                  [size]="'lg'"
                  (click)="flowPagesService.navigateBack()"
                />
              }
              <span class="wrapper__right-title-group">
                <span class="wrapper__right-title typo-title-4">
                  {{ flowPagesService.activePage()?.title }}
                </span>
                @if (flowPagesService.activePage()?.subtitle) {
                  <span class="wrapper__right-subtitle typo-text-2">
                    {{ flowPagesService.activePage()?.subtitle }}
                  </span>
                }
              </span>
              @if (flowPagesService.activePage()?.canClose) {
                <kc-icon
                  class="wrapper__right-close"
                  [iconClass]="'icon-close'"
                  [size]="'md'"
                  (click)="onFlowPageClose()"
                />
              }
            </div>
          } @else {
            <span class="wrapper__right-title typo-title-4">Workspace</span>
          }
        </div>

        <!-- Right-panel body -->
        <div class="wrapper__right-body">
          @if (flowPagesService.isAnyPageOpen()) {
            <app-dynamic-flow-page-outlet />
          } @else {
            <!-- Placeholder shown when no action is active -->
            <div class="wrapper__right-placeholder">
              <div class="wrapper__right-placeholder-icon">
                <svg
                  width="48"
                  height="48"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="1.2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <rect x="3" y="3" width="7" height="7" rx="1" />
                  <rect x="14" y="3" width="7" height="7" rx="1" />
                  <rect x="3" y="14" width="7" height="7" rx="1" />
                  <path d="M14 14h7v7h-7z" opacity="0.35" />
                </svg>
              </div>
              <p class="wrapper__right-placeholder-text">
                Open Swap or another action<br />to see it here
              </p>
            </div>
          }
        </div>
      </div>
    } @else {
      <!-- ── NORMAL MODE: existing single-column layout ── -->
      <div
        [@navAnimation]="getRouteAnimationData()"
        class="wrapper__content full-width"
      >
        <div class="wrapper__header">
          <app-wrapper-header />
        </div>
        <router-outlet #outlet="outlet" />
      </div>

      <div class="wrapper__nav" [class.hide]="isContractsWide()">
        <app-wrapper-nav />
      </div>

      <!-- Flow Pages System (overlay) – only in normal mode -->
      <app-flow-page
        [isOpen]="flowPagesService.isAnyPageOpen()"
        [title]="flowPagesService.activePage()?.title || ''"
        [subtitle]="flowPagesService.activePage()?.subtitle || ''"
        [canNavigateBack]="flowPagesService.canNavigateBack()"
        [canClose]="flowPagesService.activePage()?.canClose ?? false"
        [showTitle]="flowPagesService.activePage()?.showTitle ?? true"
        [showBackground]="flowPagesService.activePage()?.showBackground ?? true"
        (navigateBack)="flowPagesService.navigateBack()"
        (backdropClick)="onFlowPageBackdropClick()"
        (close)="onFlowPageClose()"
      >
        <app-dynamic-flow-page-outlet />
      </app-flow-page>
    }

    <!-- Quick Action Dialog – always present -->
    <app-dynamic-quick-action-dialog-outlet />
  </div>
</div>
